import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { BACKEND } from "@/lib/api";

export default function QrRedirect() {
  const { code } = useParams();
  const { search } = useLocation();
  const url = `${BACKEND}/api/qr/${encodeURIComponent(code)}${search}`;

  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return (
    <div className="ym-dark min-h-screen grid place-items-center text-center p-6" data-testid="qr-redirect-page">
      <a href={url} className="eyebrow" data-testid="qr-redirect-link">Menüye yönlendiriliyorsunuz…</a>
    </div>
  );
}
